module.exports = __webpack_public_path__ + "static/groundbeefpatties-fea54d9d14e39f11f5d60e22cf9072f8.jpg";